import { memo, useContext } from 'react';

import styled from '@emotion/styled';
import { themeFont } from '../../lib/themeFont';
import useDateDisplayWithFormat from '../../lib/useDateDisplayWithFormat';
import { WWContext, type WWContextValue } from '../WWContext';

import { isWwsWeddingWebsiteV2 } from '../../types/graphql';

import type { ThemeProps } from '@emotion/react';
import type { CSSObject } from '@emotion/styled';

const DateLocationLockupWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${({ theme }: ThemeProps): CSSObject | undefined =>
    theme.components.DateLocationLockup}

  ${themeFont('s2')}
`;

const DateLocationLockupDivider = styled('div')`
  margin: 32px 0;
  width: 100%;
  border-bottom: 1px solid
    ${({ theme }: ThemeProps) =>
      theme.components.DateLocationLockup?.borderColor || theme.fonts.s4.color};
`;

const DateLocationLockupContent = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 32px;
`;

function SinglePageDateLocationLockup() {
  const { data } = useContext<WWContextValue>(WWContext);

  const formattedDate = useDateDisplayWithFormat('natural');

  if (!isWwsWeddingWebsiteV2(data?.weddingWebsiteResult)) {
    return null;
  }

  const [city, state] = data?.weddingWebsiteResult?.weddingLocation?.split(
    ','
  ) || ['', ''];

  const [day, year] = formattedDate?.split(',') || ['', ''];

  const { countdownDays } = data.weddingWebsiteResult;

  return (
    <DateLocationLockupWrapper>
      <DateLocationLockupContent>
        {data?.weddingWebsiteResult.hideDate && 'Date TBA'}
        {!data?.weddingWebsiteResult.hideDate && (
          <>
            <span>{day}</span>
            <span>{year}</span>
          </>
        )}
      </DateLocationLockupContent>
      <DateLocationLockupDivider />
      <DateLocationLockupContent>
        <span>{city}</span>
        <span>{state}</span>
      </DateLocationLockupContent>
      {countdownDays != null && (
        <>
          <DateLocationLockupDivider />
          <DateLocationLockupContent>
            {`${countdownDays} ${countdownDays === 1 ? 'Day' : 'Days'} To Go!`}
          </DateLocationLockupContent>
        </>
      )}
    </DateLocationLockupWrapper>
  );
}

export default memo(SinglePageDateLocationLockup);
